// Shorten a hex string for display in debug payloads. Length 10 = "0x" + 8 hex
// chars, enough to correlate hashes/signatures across a copy-pasted dump
// without leaking the full value.
export function prefixHex<T extends string>(
  value: T | null | undefined,
  len = 10,
): T | null {
  if (typeof value !== 'string' || value.length < len) return null;
  return value.slice(0, len) as T;
}
